<div class="min-h-[100vh] flex flex-col">
    <div
        id="header"
        class="sticky top-0 z-50 bg-white py-3 lg:shadow-none"
        [ngClass]="isPublicPreviewRoute ? '' : 'border-b-[1px] border-b-[#d5e5f6] shadow-sm'">
        <app-header
            [isAuthLayout]="isPublicPreviewRoute"
            [showLanguageDropdown]="true"></app-header>
        @if (!isPublicPreviewRoute) {
            <app-desktop-navbar></app-desktop-navbar>
        }
    </div>

    <div class="flex-1 flex flex-col h-full">
        <router-outlet class="h-full w-full block"></router-outlet>
        <div class="back-to-top-holder" [class.hidden]="hideGotoTopButton">
            <button type="button" (click)="gotoTopScreen()">
                <span class="goto-top-btn block"></span>
            </button>
        </div>
    </div>

    <app-footer></app-footer>

    @if (isFirstTimeJourney) {
        <app-journey-block-ui
            [hasAaePermission]="userDetails.isAAEEnabled"
            [userLastSteps]="userLastSteps"></app-journey-block-ui>
    }
</div>
